import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import type { ICategory } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import CreateButton from "../../components/common/CreateButton";
import { useListPage } from "../../hooks";
import RowActions from "../../components/table/RowActions";

interface ICategoryRecord extends Pick<ICategory, '_id' | 'code' | 'isActive' | 'isFeatured' | 'order' | 'title' | 'categoryNumber' | 'createdAt'>{
    actions: unknown;
}

const CategoryList = () => {

    const { paginationState, records, handleInteraction, deleteRecord } = useListPage({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    });

    const columns: Column<ICategoryRecord>[] =  [
        {
            Header: 'Код',
            accessor: 'code',
        },
        {
            Header: 'Нэр',
            accessor: 'title'
        },
        {
            Header: 'Бүлгийн дугаар',
            accessor: 'categoryNumber'
        },
        {
            Header: 'Дараалал',
            accessor: 'order',
        },
        {
            Header: 'Онцолсон эсэх',
            accessor: 'isFeatured',
            Cell: ({ value }) => {
                return <TableIndicator active={value} color={value ? 'orange' : undefined}/>;
            },
            width: 1
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүссэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY.MM.DD HH:mm')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default CategoryList;